// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the location details header */
.location_locationHeader__tjmbb {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background-color: #3b82f6;
  border-radius: 5px;
}

/* Store name */
.location_storeName__Kv3M\\+ {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  color: white;
}

/* Close button */
.location_closeButton__CtHnh {
  color: white !important;
}

/* Details container */
.location_detailsContainer__8VJtD {
  padding: 5px;
  display: flex;
  align-items: start;
  justify-content: start;
  width: fit-content;
  border: 1px solid #418cff;
  border-radius: 5px;
  margin-top: 2px;
}

/* Label styling */
.location_detailsLabel__XfLa6 {
  font-size: 12px;
  color: black;
  font-weight: 800;
  margin-bottom: 4px;
}

/* Value styling */
.location_detailsValue__eJMky {
  font-size: 12px;
  color: #555;
  margin-left: 5px;
}

/* Address styling */
.location_address__aseQz {
  font-size: 12px;
  color: #555;
  margin-left: 5px;
  display: block;
  max-width: 180px;
  word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/styles/location.module.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":["/* Container for the location details header */\n.locationHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px;\n  background-color: #3b82f6;\n  border-radius: 5px;\n}\n\n/* Store name */\n.storeName {\n  margin: 0;\n  font-size: 14px;\n  font-weight: bold;\n  color: white;\n}\n\n/* Close button */\n.closeButton {\n  color: white !important;\n}\n\n/* Details container */\n.detailsContainer {\n  padding: 5px;\n  display: flex;\n  align-items: start;\n  justify-content: start;\n  width: fit-content;\n  border: 1px solid #418cff;\n  border-radius: 5px;\n  margin-top: 2px;\n}\n\n/* Label styling */\n.detailsLabel {\n  font-size: 12px;\n  color: black;\n  font-weight: 800;\n  margin-bottom: 4px;\n}\n\n/* Value styling */\n.detailsValue {\n  font-size: 12px;\n  color: #555;\n  margin-left: 5px;\n}\n\n/* Address styling */\n.address {\n  font-size: 12px;\n  color: #555;\n  margin-left: 5px;\n  display: block;\n  max-width: 180px;\n  word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationHeader": `location_locationHeader__tjmbb`,
	"storeName": `location_storeName__Kv3M+`,
	"closeButton": `location_closeButton__CtHnh`,
	"detailsContainer": `location_detailsContainer__8VJtD`,
	"detailsLabel": `location_detailsLabel__XfLa6`,
	"detailsValue": `location_detailsValue__eJMky`,
	"address": `location_address__aseQz`
};
export default ___CSS_LOADER_EXPORT___;
